import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { asyncConnect } from 'redux-async-connect';
import { Router, Route, Link } from 'react-router'
import { Operating } from 'components';



@asyncConnect([{
  promise: ({store: {dispatch, getState}}) => {
    const promises = [];
    // if (!isInfoLoaded(getState())) {
    //   promises.push(dispatch(loadInfo()));
    // }
    return Promise.all(promises);
  }
}])
export default class TakePasswordOne extends Component {
  constructor(props,context) {
    super(props,context);
  }
  render() {
    return (
      <Operating >
      <div style={{height:"100px"}}></div>
      </Operating>
    );
  }
}
